import FooterComponent from './FooterComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = () => ({});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

// Create higher-order component which feeds in specified props.
const FooterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterComponent);

export default FooterContainer;



// WEBPACK FOOTER //
// ./src/components/common/Footer/FooterContainer.js